const isResolvedResource = require('../contentful/is-resolved-resource');
const modelTransformer = require('./model');

const createLink = (asset, type) => {
  return {
    sys: {
      type: 'Link',
      linkType: type,
      id: asset.id
    }
  };
};

module.exports = {
  contentfulToInternal(entry) {
    // console.log("Entry trans", entry);
    const result = {
      id: entry.sys.id,
      published: Boolean(entry.sys.publishedVersion),
      updated: entry.sys.publishedVersion && entry.sys.version > entry.sys.publishedVersion + 1,
      draft: !entry.sys.publishedVersion,
      archived: Boolean(entry.sys.archivedVersion),
      contentType: null,

      name: entry.fields.name ? entry.fields.name['nb-NO'] : '',
      tags: [],
      model: null,
      deactivatedText: entry.fields.deactivatedText ? entry.fields.deactivatedText['nb-NO'] : '',
      custom: (entry.fields.custom ? entry.fields.custom['nb-NO'] : null)
    };

    if (entry.sys && entry.sys.contentType) {
      result.contentType = entry.sys.contentType.sys.id;
    }

    if (entry.fields.tags) {
      result.tags = entry.fields.tags['nb-NO'];
    }

    // Handle model link:
    if (entry.fields.model && entry.fields.model['nb-NO'] && isResolvedResource(entry.fields.model['nb-NO'])) {
      result.model = modelTransformer.contentfulToInternal(entry.fields.model['nb-NO']);
    }

    return result;
  },

  internalToContentful(variantGroup) {
    const result = {
      fields: {
        name: {
          'nb-NO': variantGroup.name
        },
        tags: null,
        deactivatedText: null
      }
    };

    let tags = [];
    if (variantGroup.tags.length > 0) {
      tags = variantGroup.tags;
    }
    result.fields.tags = {
      'nb-NO': tags
    };

    if (variantGroup.deactivatedText) {
      result.fields.deactivatedText = {
        'nb-NO': variantGroup.deactivatedText
      };
    }

    if (variantGroup.custom) {
      result.fields.custom = {
        'nb-NO': true
      };

      if (variantGroup.modelId) {
        result.fields.model = {
          'nb-NO': createLink({id: variantGroup.modelId}, 'Entry')
        };
      }
    }

    return result;
  }
};
